import '@/modules/card';
import '@/modules/pagination';
import { FacetFilters, FacetFiltersForm, PriceRange, FacetRemove } from '@/modules/filter';

if (document.getElementsByTagName('facet-filters-form')) {
    if(!customElements.get('face-filters')) {
        customElements.define('facet-filters', FacetFilters);
    }
    
    customElements.define('facet-filters-form', FacetFiltersForm);
    customElements.define('price-range', PriceRange);
    customElements.define('facet-remove', FacetRemove);
}
